import { LRUCache } from 'lru-cache'

const options = {
  max: 500,
  maxSize: 5000,
  sizeCalculation: (value, key) => {
    return 1
  },
  dispose: (value, key) => {
    // 
  },
  ttl: 1000,
  allowStale: false,
  updateAgeOnGet: false,
  updateAgeOnHas: false,
}

const cache = new LRUCache(options)

export default cache